import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import type { getSimulate } from './simulate';

/**
 * Whether the current sim result is a verified success, and whether such a result has been shown
 * for a *settled* bundle at least once in this review (latched — a later rebuild keeps it).
 *
 * Without the latch, reopening a review inside the query's `gcTime` would flash the cached result
 * of the previous bundle (possibly built with a different prefix) as "success" before the current
 * bundle has even settled.
 */
export function useVerifiedSimulationResult(t0) {
  const $ = _c(3);
  const {
    data,
    error,
    isSettled
  } = t0;
  const hasVerifiedResult = data?.success === true && !error;
  const isSettledNow = hasVerifiedResult && isSettled;
  const [hasSettledBefore, setHasSettledBefore] = useState(false);
  if (!hasSettledBefore && isSettledNow) {
    setHasSettledBefore(true);
  }
  const t1 = hasSettledBefore || isSettledNow;
  let t2;
  if ($[0] !== hasVerifiedResult || $[1] !== t1) {
    t2 = {
      hasVerifiedResult,
      hasSettledResult: t1
    };
    $[0] = hasVerifiedResult;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}